import "./About.css";
import author from "../../Images/Brand/Author.png";
import { Ctabanner, Footer, Nav, QuickReview, Social } from "../../Components/ExportComponents";
import { useState } from "react";
import authorbig from "../../Images/Brand/authorBig.png";
import thevisuallogo from "../../Images/Brand/logo.png"
import { useNavigate } from "react-router-dom";

import img1 from "../../Images/img/3D icon.jpg";
import img2 from "../../Images/img/Back.jpg";
import img3 from "../../Images/img/T_Shirt-1.jpg";
import img4 from "../../Images/img/board.jpg";
import img5 from "../../Images/img/building1.jpg";
import img6 from "../../Images/img/card.jpg";
import img7 from "../../Images/img/app.jpg";

import { Helmet } from "react-helmet"; // ✅ Added Helmet

const About = () => {
    const [menuBar, setMenuBar] = useState(false);
    const LinkTo = useNavigate();

    return (
        <>
            {/* Page-specific SEO */}
            <Helmet>
                <title>About Bhanubhakta Sapkota | The Visual Designer</title>
                <meta name="description" content="Learn about Bhanubhakta Sapkota, a creative graphic designer, UI/UX designer, branding expert, and mentor from Pokhara, Nepal." />

                {/* Open Graph */}
                <meta property="og:title" content="About Bhanubhakta Sapkota | The Visual Designer" />
                <meta property="og:description" content="Learn about Bhanubhakta Sapkota, a creative graphic designer, UI/UX designer, branding expert, and mentor from Pokhara, Nepal." />
                <meta property="og:image" content="https://thevisualdesigner.co/static/media/authorBig.png" />
                <meta property="og:url" content="https://thevisualdesigner.co/about" />
                <meta property="og:type" content="website" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="About Bhanubhakta Sapkota | The Visual Designer" />
                <meta name="twitter:description" content="Learn about Bhanubhakta Sapkota, a creative graphic designer, UI/UX designer, branding expert, and mentor from Pokhara, Nepal." />
                <meta name="twitter:image" content="https://thevisualdesigner.co/static/media/authorBig.png" />

                {/* Canonical */}
                <link rel="canonical" href="https://thevisualdesigner.co/about" />
            </Helmet>

            <div className="backgroundBig">
                <span className="mainBackgroundHR"></span>
                <span className="mainBackgroundHRleft"></span>
                <div className="mainBackgroundHRRight"></div>
                <span className="mainBackgroundHRright"></span>
                <span className="mainBackgroundBig"></span>
                <span className="mainBackgroundBigRight"></span>
                <div className="smallBack">
                    <div className="topLeftInternal"></div>
                    <div className="topLeftInternal2"></div>

                    <div className="topRightInternal"></div>
                    <div className="topRightInternal2"></div>
                    <Nav setMenuBar={setMenuBar} menuBar={menuBar} />
                    <div className="aboutPage">
                        <div className="aboutPageIntro">
                            <div className="uProfile">
                                <div className="left">
                                    <img src={author} alt="Bhanubhakta Sapkota profile" />
                                </div>
                                <div className="right">
                                    <div className="name">Bhanubhakta_Sapkota</div>
                                    <div className="post">Graphic Designer</div>
                                </div>
                            </div>

                            <div className="aboutMeAuthor">
                                <h1>
                                    Hi, it’s me{" "}
                                    <span className="boldText">Bhanubhakta Sapkota</span>, known as The Visual Designer.{" "}
                                    <span onClick={() => LinkTo("https://www.instagram.com/thevisualdesigner.co/")} className="linkAbout orangedText">
                                        <u>@thevisualdesigner.co</u>
                                    </span>
                                </h1>
                            </div>

                            <div className="aboutMeAuthorDesc">
                                Graphic Designer | UI/UX Designer | Branding & Logo Designer | Digital Marketing | Mentor
                            </div>
                        </div>
                        <div className="aboutMeBigImage">
                            <span className="aboutImgLeftBottom"></span>
                            <span className="aboutImgRightTop"></span>
                            <img src={authorbig} alt="Bhanubhakta Sapkota big portrait" />
                            <div className="smallScrollAbout">
                                <div className="imgageNText">
                                    <img src={thevisuallogo} alt="The Visual Designer Logo" />
                                    <div className="scrollMe">
                                        <span>Bhanubhakta</span>
                                        <span>Thevisualdesigner</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="descAbout">
                            Committed Creative Designer from Pokhara, Nepal specializing in transforming ideas into cohesive visual & digital systems that work-strategically, aesthetically, & commercially.
                        </div>

                        <div className="descAbout2">
                            With{" "}
                            <span className="boldText">5+ years of experience</span>, I work across{" "}
                            <span className="boldText orangedText">
                                Graphic Design, UI/UX, Branding, Logo Design, and Digital Marketing
                            </span>.
                            My focus is simple – helping brands gain clarity, consistency, and results
                            through intentional design and well-planned digital strategies.
                        </div>

                        <QuickReview />

                        <div className="descAbout">
                            I’ve collaborated with clients locally and globally, including NeolinFX, TrailingBot, and several national brands - delivering brand identities, digital products, marketing materials, and user-centered design solutions crafted for real business impact.
                        </div>
                        <div className="scrollImagesAbout">
                            <div className="imageCollection">
                                <div className="image">
                                    <img src={img1} alt="3D Icon Design" />
                                </div>
                                <div className="image">
                                    <img src={img2} alt="Background Design" />
                                </div>
                                <div className="image">
                                    <img src={img3} alt="T-Shirt Graphic Design" />
                                </div>
                                <div className="image">
                                    <img src={img4} alt="Board Design" />
                                </div>

                                <div className="image">
                                    <img src={img5} alt="Building Design" />
                                </div>
                                <div className="image">
                                    <img src={img6} alt="Business Card Design" />
                                </div>
                                <div className="image">
                                    <img src={img7} alt="App Interface Design" />
                                </div>

                            </div>
                        </div>
                        <div className="descAbout3">
                            My work centers on solving communication challenges through design and marketing - ensuring every visual, interface, or campaign feels purposeful, functional, and aligned with long-term brand goals.
                        </div>
                        <div className="descAboutLight">
                            Currently based in Pokhara, Nepal, working remotely with clients from different countries and industries.
                        </div>
                    </div>
                    <Ctabanner />
                    <Social />
                    <Footer />
                </div>
            </div>
        </>
    )
}
export default About;
